<template>
  <div class="podcast">
    <div class="typeMenu maxWidth pad">
      <div class="typeMenuCon">
        <div class="typeMenuConL">
          <span>分类</span>
        </div>
        <div class="typeMenuConR" :class="{ open: isOpenTypeMenu }">
          <ul>
            <li class="item" v-for="(item, index) in tabList" :key="index">
            <router-link :to="'/podcast/'+item.id">
              <span :class="{ active: item.id == fontCurrent }">{{
                item.title
              }}</span>
            </router-link>
            </li>
          </ul>
        </div>
        <div
          class="js-moreTypeMenu"
          :class="{ open: isOpenTypeMenu }"
          v-if="isShowMoreTypeMenu"
          @click="isOpenTypeMenu = !isOpenTypeMenu"
        ></div>
      </div>
    </div>

    <div class="topNews maxWidth" v-if="isRecommend">
      <div class="topNewsCon">
        <div class="topNewsConL">
          <dl v-for="(item, key) in recommend.slice(0, 1)" :key="key">
            <router-link :to="typeObj[item.type+'']+'/'+item.type+'/'+item.id">
              <dt>
                <img :src="item.picurl" alt="" />
                <div class="current"></div>
              </dt>
              <dd>
                <h4>{{ item.title }}</h4>
              </dd>
            </router-link>
          </dl>
        </div>
        <div class="topNewsConR">
          <dl v-for="(item, key) in recommend.slice(1,5)" :key="key">
            <router-link :to="typeObj[item.type+'']+'/'+item.type+'/'+item.id">
              <dt>
                <img :src="item.picurl" alt="" />
                <div class="current"></div>
              </dt>
              <dd>
                <h4>{{ item.title }}</h4>
              </dd>
            </router-link>
          </dl>
        </div>
      </div>
    </div>

    <div
      class="maxWidth mod pad"
      v-for="(item, index) in titleList"
      :key="index"
    >
      <h2 class="mod-title">
        <router-link
          :to="'/laneList/'+'add/' + item.id"
          class="more"
          v-if="item.hasDetail !== 0"
          >更多></router-link
        >
        <strong>{{ item.title }}</strong>
      </h2>
      <div class="photoThreeCon">
        <dl
          v-for="(item1, index1) in item.data"
          :key="index1"
          @click="toOtherDetail(item1)"
        >
          <router-link :to="typeObj[item1.type+'']+'/'+item1.type+'/'+item1.id">
            <dt>
              <img :src="item1.picurl" alt="" />
            </dt>
            <dd>
              <h4>{{ item1.title }}</h4>
            </dd>
          </router-link>
        </dl>
      </div>
    </div>
    <!-- <div class="maxWidth ad">
      <router-link to="">
        <img src="../../static/img/file/banner@1165-158.jpg" alt="" />
      </router-link>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "Podcast",
  data() {
    return {
      //
      //tabList
      tabList: [],
      isRecommend:false,
      recommend:[],
      // 内容list
      titleList: [],
      screenWidth: document.documentElement.clientWidth,
      isShowMoreTypeMenu: false,
      isOpenTypeMenu: false,
      //current  tab 字体颜色
      fontCurrent: this.$route.params.pId,
      tabId: this.$route.params.pId,
      typeObj:{
        ezfm:"/columnList",
        other:"/columnList",
        recommend:"/detail",
        ezfmHistory:"/detail",
        otherHistory:"/detail",
        more:"/detail",
        lane:"/laneList"
      }
    };
  },
  methods: {
    toOtherDetail(item) {
    },
    //获取 当前tab 切换内容
    getNowList(index) {
      var _this = this;
      if (index !== null && index !== undefined) {
        _this.fontCurrent = index;
      }
      // 调接口  https://aezfm.meldingcloud.com/v3/classification/detail?id=15
      if(_this.tabId != undefined){
        _this.$http
        .post("/qertyuiy/v3/classification/detail?id=" + _this.tabId)
        .then(function (res) {
          //tab
          _this.titleList = res.data.data.lanes;
          if('recommend' in res.data.data){
            _this.isRecommend = true;
            _this.recommend = res.data.data.recommend;
          }
          for(var i=0;i<_this.titleList.length;i++){
            if(_this.titleList[i].hasDetail == 1){
              _this.titleList[i].data = _this.titleList[i].data.slice(0,6);
            }
          }
        });
      }
      
    },
    // 获取list tab
    getList() {
      var _this = this;
      //https://aezfm.meldingcloud.com/v3/classification
      _this.$http.post("/qertyuiy/v3/classification").then(function (res) {
        var arr = res.data.data;
        var arr1 = [];
        for (var i = 0; i < arr.length; i++) {
          if (arr[i].type == 0) {
            arr1.push(arr[i]);
          }
        }
        _this.tabList = arr1;
        
        if (_this.screenWidth <= 900) {
          _this.ifTypeMenuHeight();
        }
        
      });
    },
    // --
    ifTypeMenuHeight: function () {
      var _this = this;
      _this.$nextTick(function () {
        var fatherHeight = parseInt($(".typeMenuConR").height()),
          childHeight = parseInt($(".typeMenuConR ul").height());
        if (childHeight > fatherHeight) {
          _this.isShowMoreTypeMenu = true;
        } else {
          _this.isShowMoreTypeMenu = false;
        }
      });
    },
  },
  mounted: function () {
    
  },
  created: function () {
    this.getList();
    this.getNowList();
  },
};
</script>



// WEBPACK FOOTER //
// src/page/PodcastList.vue